import React from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import { SentimentDissatisfied as SadIcon } from '@mui/icons-material';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
        }}
      >
        <Paper elevation={3} sx={{ p: 5, textAlign: 'center', width: '100%' }}>
          <SadIcon sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
          
          <Typography variant="h1" component="h1" gutterBottom>
            404
          </Typography>
          
          <Typography variant="h4" component="h2" gutterBottom>
            Seite nicht gefunden
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            Die angeforderte Seite existiert nicht oder der Link ist abgelaufen.
          </Typography>
          
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/"
              size="large"
            >
              Zurück zur Startseite
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;